import cloneDeep from 'lodash/cloneDeep'
import baseDefaults from '../Base/Base.defaults'

export default {
  ...cloneDeep(baseDefaults),
  columns: [ {}, {}, {}, {}, {}, {} ],
  gap: {
    desktop: 0,
  },
  distribution: {
    desktopDistribution: undefined,
    mobileDistribution: "12",
    tabletDistribution: "12"
  },
  initialized: false
}
